module.exports = "fragment Storefront on Storefront {\n  __typename\n  mugshot {\n    url(width: 135, height: 135, fitIn: true)\n  }\n  biography\n  slug\n}\n"